<template>
  <v-row class="mt-2" justify="end" align="center">
    <v-col cols="auto">
      <span class="mr-4">
        Rows per page:
      </span>
      <v-select
        v-model="localItemsPerPage"
        :items="[10, 20, 50, 100]"
        dense
        hide-details
        class="d-inline-block mr-4"
        style="width: 70px"
        @change="onItemsPerPageChange"
      ></v-select>
      <span class="text-body-2 mr-4">
        {{ (currentPage - 1) * itemsPerPage + 1 }}-{{
          Math.min(currentPage * itemsPerPage, total)
        }}
        of {{ total }}
      </span>
      <v-btn
        icon
        class="ml-4"
        :disabled="currentPage === 1"
        @click="onPageChange(currentPage - 1)"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        icon
        :disabled="currentPage >= lastPage"
        @click="onPageChange(currentPage + 1)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "MyPagination",
  props: {
    meta: {
      type: Object,
      required: true,
      validator: value => {
        return (
          value &&
          (typeof value.total === "number" ||
            typeof value.total === "string") &&
          (typeof value.last_page === "number" ||
            typeof value.last_page === "string") &&
          (typeof value.current_page === "number" ||
            typeof value.current_page === "string") &&
          (typeof value.per_page === "number" ||
            typeof value.per_page === "string")
        );
      }
    }
  },
  data() {
    return {
      localItemsPerPage: Number(this.meta.per_page)
    };
  },
  computed: {
    currentPage() {
      return Number(this.meta.current_page);
    },
    itemsPerPage() {
      return Number(this.meta.per_page);
    },
    total() {
      return Number(this.meta.total);
    },
    lastPage() {
      return Number(this.meta.last_page);
    }
  },
  methods: {
    onPageChange(page) {
      this.$emit("request-page", {
        page,
        itemsPerPage: this.itemsPerPage
      });
    },
    onItemsPerPageChange(itemsPerPage) {
      console.log("onItemsPerPageChange fired", itemsPerPage);
      this.$emit("request-page", {
        page: 1, // Reset to first page when changing items per page
        itemsPerPage
      });
    }
  }
};
</script>
